import { render } from "./category-list.vue?vue&type=template&id=7ee08d48&scoped=true"
const script = {}

import "./category-list.vue?vue&type=style&index=0&id=7ee08d48&lang=scss&scoped=true"

import exportComponent from "/data/project/activity-v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ee08d48"]])

export default __exports__